'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidVolumeOff = function IoAndroidVolumeOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 20c0-5.4-3.5-10-8.3-11.5v-3.5c6.6 1.6 11.6 7.7 11.6 15 0 2.7-0.6 5.3-1.9 7.5l-2.5-2.5c0.7-1.5 1.1-3.2 1.1-5z m-11.7-13.7v8.1l-4-4z m12.9 24.7l1.9 1.9-1.9 1.9-3.1-3.2c-1.8 1.7-4 2.9-6.4 3.4v-3.5c1.4-0.5 2.9-1.2 4-2.2l-7.4-7.4v11.9l-8.4-8.8h-6.6v-10h6.6l0.7-0.8-7.1-7.1 1.9-1.9z m-5.4-11c0 0.5 0 1.2-0.2 1.7l-3.9-4v-4.7c2.5 1.3 4.1 4 4.1 7z' })
        )
    );
};

exports.default = IoAndroidVolumeOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-volume-off.js
// module id = 2405
// module chunks = 168707334958949